import { EnumLang } from '../defines'
import { GlobalEnv } from '../global_env'

const NetworkErrorMessage = {
  [EnumLang['zh-CN']]: '网络问题，请稍后再试',
  [EnumLang['zh-HK']]: '網絡問題，請稍後再試',
  [EnumLang['en-US']]: 'Network error. Please try again later',
}

const errorMessageFriendly = errMsg => {
  if (
    errMsg?.indexOf('request:fail Error:') > -1 ||
    errMsg?.indexOf('jsError') > -1
  ) {
    return NetworkErrorMessage[GlobalEnv.lang]
  }
  return errMsg
}

/**
 * 处理错误对象，生成提示文本
 * @param {Error} error - 错误对象
 * @return {string} 提示文本
 */
export const getErrorMessage = (error, { friendly = true } = {}) => {
  // 内置请求需要.extra，trade-sdk中不需要extra
  const err = error.extra || error
  if (err?.message === 'Response Error.') {
    return friendly ? errorMessageFriendly(err?.errmsg) : err?.errmsg
  }
  if (err?.requestConfig) {
    // 是 webx request 出错
    return friendly ? errorMessageFriendly(err.errMsg) : error.errMsg
  }
  if (err?.message) {
    return friendly ? errorMessageFriendly(err?.message) : err?.message
  }

  return '程序错误'
}
